export const browser = require("bowser").getParser(window.navigator.userAgent);

const supportedOperatingSystems = ['macos', 'windows', 'ios', 'chrome os', 'android'];
const browserRequirements = {
  chrome: ">=60",
  firefox: ">=60",
  edge: ">=16",
  safari: ">=11.1",
};

export default {
  ...browser.getResult(),
  isMobilePlatform: isMobilePlatform(),
  hasCompatibleOS: hasCompatibleOS(),
  hasCompatibleBrowser: hasCompatibleBrowser(),
  getBrowserForSession: getBrowserForSession,
};

function getBrowserForSession() {
  return {
    name: browser.getBrowserName(),
    version: browser.getBrowserVersion(),
    os: browser.getOSName(),
  };
}

function isMobilePlatform() {
  return browser.getPlatformType().toLowerCase() === 'mobile';
}

function hasCompatibleOS() {
  return supportedOperatingSystems.includes(browser.getOSName().toLowerCase());
}

function hasCompatibleBrowser() {
  if (browser.getOSName().toLowerCase() === 'ios' && browser.getPlatformType() === 'tablet') {
    return true;
  }

  return browser.satisfies(browserRequirements);
}
